import axios from 'axios';
import { useQuery } from 'react-query';
import Config from '../global/env';
import { EnrollmentsData } from '../model/enrollment';

const fetchData = async (): Promise<EnrollmentsData> => {
    const { data } = await axios.get(Config.apiBaseURL + Config.enrollmentsURL);
    return data;
}

const useEnrollments = () => {
    return useQuery<EnrollmentsData, Error>('visionaware', fetchData)
}

export default useEnrollments;